import { hookstate } from "@hookstate/core";

export type ReaderComponentsState = {
  isOverlayOpen?: boolean;
  showEndInterstitial?: boolean;
  vpScale?: number;
};
const DEFAULT_COMPONENTS_STATE = {
  showEndInterstitial: false,
  isOverlayOpen: false,
  vpScale: 1,
};

export const readerComponentsStore = hookstate<ReaderComponentsState>(
  DEFAULT_COMPONENTS_STATE,
);
